import React from 'react'
import Logo from '../Logo'
import './index.styl'

const LayoutSwitcher = ({ type }) => {
  return (
    <div className='logoSwitcher'>
      <Logo />
    </div>
  )
}

export default LayoutSwitcher
